module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Bright.4c6819e3.png";